import React, { useEffect, useState } from "react";

export function useMobileView(width = 435) {
  const mobileWidth = parseInt(width);
  const [isMobileView, setMobileView] = useState(window.innerWidth <= mobileWidth);

  useEffect(() => {
    function handleResize() {
      setMobileView(window.innerWidth <= mobileWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    }
  }, []);

  return isMobileView;
}

export function withMobileView(Component) {
  return function WrappedComponent(props) {
    const isMobileView = useMobileView();
    return (
      <Component {...props} isMobileView={isMobileView} />
    );
  }
}
